import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  contract: Yup.string().required('El campo es requerido').min(1, 'Ingresa un contrato válido.'),
  identificationType: Yup.string().required('El campo es requerido'),
  identification: Yup.string().required('El campo es requerido').min(1, 'Ingresa una identificación válida.'),
});
